import { Component, Input, OnInit } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { ActivatedRoute } from "@angular/router";
import { EssentialService } from "../../services/essential.service";

@Component({
  selector: "lib-search-result",
  templateUrl: "./search-result.component.html",
  styleUrls: ["./search-result.component.css"],
})
export class SearchResultComponent implements OnInit {
  @Input() public settings: any;
  @Input() public data: any;
  pageSize: any = "10";
  currentPage: number = 1;
  totalCount: number;
  listItems: any[] = [];
  searchValue: string = "";
  SearchOptionId: string = "";
  SubSearchOptions: any[] = [];
  isLoading: boolean = false;
  public apiUrl = window["config"].apiUrl + "/";
  site: any;

  constructor(
    private activatedRoute: ActivatedRoute,
    private essentialService: EssentialService,
    private sinitizer: DomSanitizer
  ) {}

  ngOnInit() {
    this.site = this.data.moduleService.site;

    this.activatedRoute.queryParams.subscribe((param) => {
      this.searchValue = param["search"];
      this.SearchOptionId = param["searchOptionId"];
      this.SubSearchOptions = param["subSearchOptions"];
      if (param["search"]) {
        this.isLoading = true;
        this.currentPage = 1;
        this.getData();
      } 
    });
  }

  getSearchText() {
    this.activatedRoute.queryParams.subscribe((param) => {
      this.searchValue = param["search"];
      this.SearchOptionId = param["searchOptionId"];
      this.SubSearchOptions = param["subSearchOptions"];
    });
  }
  getData() {
    this.isLoading = true;
    this.activatedRoute.queryParams.subscribe((param) => {
      var query: any = {
        searchValue: param["search"],
        pageSize: this.pageSize,
        pageNumber: this.currentPage,
        searchOptionId: param["searchOptionId"],
        subSearchOptions: param["subSearchOptions"],
      };
      this.essentialService.search(query).subscribe((data: any) => {
        this.totalCount = data.totalLength;

        if (Object.keys(data).length) {
          this.listItems = data.listItems;
        }
        this.isLoading = false;
      },(err)=>{
        this.isLoading = false;
      });
    });
  }
  getImage(img) {
    return this.sinitizer.bypassSecurityTrustUrl(img);
  }
}
